import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

const Issue = () => <Dashboard />;

export default Issue;
